module.exports = __webpack_public_path__ + "static/img/user.67351126.svg";